class BxfContextMenuConstants {
    static STRING = {
        SHOW: 'bxf-context-menu__show',
        TARGET: 'target',
        CHECK: 'checkmark',
        BOTTOM_BORDER: 'bottom-border',
        ARROW_RIGHT: 'arrow-right',
        ZOOM_IN: 'zoom-in',
        ZOOM_OUT: 'zoom-out',
        FLYOUT_DATA: 'flyoutMenu',
        FLYOUT: 'bxf-context-menu__flyout',
        ALERT: 'alert',
        MENU_ITEM: 'bxf-context-menu__item',
        MENU_ITEM_COMPACT: 'bxf-context-menu__item--compact',
        GROUP_SEPARATOR: 'bxf-context-menu__group-separator',
        MENU_LEFT_ICON: 'bxf-context-menu__lefticon',
        FLYOUT_ITEM_NOT_SELECTED: 'bxf-context-menu__lefticon-flyout--not-selected',
        MENU_RIGHT_ICON: 'bxf-context-menu__righticon',
        MENU_RIGHT_ICON_NO: 'bxf-context-menu__norighticon',
        ZOOM_CONTROLS: 'bxf-context-menu__zoom-controls',
        INNER_LABEL: 'bxf-contextmenu__inner-label',
        MENU_RIGHT_ICON_FLYOUT: 'bxf-context-menu__righticon-flyout',
        ZOOM_CONTROLS_ICON: 'bxf-context-zoom-controls-icon',
        ZOOM_CONTROLS_BUTTON: 'bxf-context-zoom-controls__button',
        ZOOM_CONTROLS_BUTTON_ACTIVE: 'bxf-context-zoom-controls__button--active',
        SELECTED: 'selected',
        DISABLED: 'disabled',
        MENU_ITEM_WRAPPER: 'bxf-context-menu__item-wrapper',
        ZOOM_IN_LABEL: 'Zoom In',
        ZOOM_OUT_LABEL: 'Zoom Out',
        CONTEXT_MENU_OVERLAY: 'bxf-context-menu--overlay',
    };
}

export { BxfContextMenuConstants as B };
